import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Grid } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { GeneralSelectMenu } from 'src/components/general';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import { PRODUCT_TYPE, PROFILE_REWARD__LIST } from 'src/constants/queryKeys';
import { networkInsertProductType } from 'src/network/product-type';
import { networkCreateProfileReward, networkUpdateProfileReward } from 'src/network/profile-reward';
import useAppInfoStore from 'src/store/appInfo';
import useFormsModalStore from 'src/store/forms';
import { generateSelectMenuItems } from 'src/utils';

const ProductTypeForm = () => {
  const { modal, closeModal } = useFormsModalStore();
  const { setModal } = useFormsModalStore();
  const [isLoading, setIsLoading] = useState(false);

  const queryClient = useQueryClient();

  const { enqueueSnackbar } = useSnackbar();

  const methods = useForm({
    // resolver: yupResolver(schema),
    // defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  // ---------------------------------------------------------------

  const onSubmit = async (values, event) => {
    if (!values?.ApplicationTypeTitle) {
      return enqueueSnackbar('عنوان را وارد کنید.', { variant: 'error' });
    }
    try {
      await networkInsertProductType({
        ApplicationTypeTitle: values?.ApplicationTypeTitle,
      });
      closeModal();
      reset();
      await queryClient.invalidateQueries({ queryKey: [PRODUCT_TYPE] });
    } catch (error) {
      enqueueSnackbar('مشکلی پیش آمده، لطفا مجددا امتحان کنید', { variant: 'error' });
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ p: 3 }}>
            <Box
              sx={{
                display: 'grid',
                columnGap: 2,
                rowGap: 3,
                gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
              }}
            >
              <RHFTextField name="ApplicationTypeTitle" type="text" label="عنوان مدل" />
            </Box>

            <div className="flex items-center gap-4 mt-6">
              <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
                ذخیره
              </LoadingButton>
              <Button onClick={closeModal} variant="contained" color="error">
                انصراف
              </Button>
            </div>
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
};

export default ProductTypeForm;
